"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BpostFill;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function BpostFill(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#231f20;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "bpost"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "bpost-fill",
    className: "cls-1",
    d: "M89.71,22C83.14,35.26,74.33,46.81,62,58.34c-12,11.2-27.67,20-38.56,20a12.84,12.84,0,0,1-8.19-2.49c-10.8-8.56-.65-31-.21-31.94a.25.25,0,0,1,.16-.14L21.9,42a.23.23,0,0,1,.25.07.27.27,0,0,1,.05.26c-3.39,8.88-3.73,15.14-1,18.59s7.27,2.76,7.32,2.76C53,60.83,71.26,27.21,71.44,26.87a.23.23,0,0,1,.15-.12l17.83-5.1a.24.24,0,0,1,.26.08A.26.26,0,0,1,89.71,22Zm-61,30.79h.14c7.68-.13,18.19-9.54,21.21-19a.24.24,0,0,0-.06-.25.25.25,0,0,0-.25-.06L24.91,41.18a.25.25,0,0,0-.16.16c-.1.27-2.22,6.59.08,9.74A4.47,4.47,0,0,0,28.69,52.79Z"
  })));
}